// import date picker
// datepicker documentation: https://mymth.github.io/vanillajs-datepicker/
import { Datepicker } from 'vanillajs-datepicker';

window.initDatePickers = () => {
    document.querySelectorAll('[data-datepicker]').forEach((element) => {
        let min_date = element.getAttribute('data-datepicker-min-date');
        let max_date = element.getAttribute('data-datepicker-max-date');

        // Ensure today is never selectable - set min_date to tomorrow if needed
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

        const pad = (n) => (n < 10 ? '0' + n : n);
        const todayString = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
        const tomorrowString = `${tomorrow.getFullYear()}-${pad(tomorrow.getMonth() + 1)}-${pad(tomorrow.getDate())}`;

        if (!min_date || min_date <= todayString) {
            min_date = tomorrowString;
        }

        // If no max_date is set, default to 3 months from today
        if (!max_date) {
            const futureDate = new Date(today.setMonth(today.getMonth() + 3));

            // Format as yyyy-mm-dd (like the rest of your picker expects)
            const pad = (n) => (n < 10 ? '0' + n : n);
            max_date = `${futureDate.getFullYear()}-${pad(futureDate.getMonth() + 1)}-${pad(futureDate.getDate())}`;
        }


        let datepicker_initialized = element.getAttribute('data-datepicker-initialized');


        element.addEventListener('click', (event) => {
            event.preventDefault();
        });


        if (datepicker_initialized === "true") {
            return;
        }

        // set initialized attribute to prevent rerunning the logic.
        element.setAttribute('data-datepicker-initialized', 'true');

        new Datepicker(element, {
            // ...options
            'orientation': 'auto',
            'autohide': true,
            'todayHighlight': true,
            'updateOnBlur': true,
            'enableOnReadonly': true,
            'daysOfWeekDisabled': [0, 1], // Sunday: 0, Saturday: 6
            'format': 'yyyy-mm-dd', // this is the format compatible with date fields
            'minDate': min_date,
            'maxDate': max_date,
            'nextArrow': '<i class="fa-solid fa-angles-right"></i>',
            'prevArrow': '<i class="fa-solid fa-angles-left"></i>',
        });
    });

    // set repeatable datepicker-initialized to false
    document.querySelectorAll('[data-repeatable-template] [data-datepicker]').forEach((element) => {
        element.setAttribute('data-datepicker-initialized', 'false');
    });
}

// prevent date field default calendar from displaying
document.querySelectorAll('[data-datepicker]').forEach((element) => {
    element.addEventListener('click', (event) => {
        event.preventDefault();
    });
});

// also call it immediately
document.addEventListener("DOMContentLoaded", (event) => {
    window.initDatePickers();
});